import { Grid, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import {
  consumableSupply_unit,
  consumableSupply_pack,
  consumableSupply_rolls,
} from '../../../../../../../data/forms/nrc/consumableSupplyDropdownOptions.js';

export default function MichiganSupplySelectForm({
  supplySelections,
  setForm,
}) {
  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prevForm => ({
      ...prevForm,
      supplySelections: {
        ...prevForm.supplySelections,
        [name]: value,
      },
    }));
  };

  return (
    <>
      <Grid size={6}>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Cash Pop Playslip'}</InputLabel>
          <Select
            value={supplySelections.cashPop}
            label={'Cash Pop Playslip'}
            onChange={handleChange}
            name='cashPop'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Classic Lotto 47 Playslip'}</InputLabel>
          <Select
            value={supplySelections.classicLotto47}
            label={'Classic Lotto 47 Playslip'}
            onChange={handleChange}
            name='classicLotto47'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Club Keno w/ Jack Playslip'}</InputLabel>
          <Select
            value={supplySelections.clubKenoJack}
            label={'Club Keno w/ Jack Playslip'}
            onChange={handleChange}
            name='clubKenoJack'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Daily 3 Playslip'}</InputLabel>
          <Select
            value={supplySelections.daily3}
            label={'Daily 3 Playslip'}
            onChange={handleChange}
            name='daily3'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Daily 4 Playslip'}</InputLabel>
          <Select
            value={supplySelections.daily4}
            label={'Daily 4 Playslip'}
            onChange={handleChange}
            name='daily4'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Daily 5 Playslip'}</InputLabel>
          <Select
            value={supplySelections.daily5}
            label={'Daily 5 Playslip'}
            onChange={handleChange}
            name='daily5'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Daily Keno Playslip'}</InputLabel>
          <Select
            value={supplySelections.dailyKeno}
            label={'Daily Keno Playslip'}
            onChange={handleChange}
            name='dailyKeno'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid size={6}>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Fantasy 5 Playslip'}</InputLabel>
          <Select
            value={supplySelections.fantasy5}
            label={'Fantasy 5 Playslip'}
            onChange={handleChange}
            name='fantasy5'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Instant Ticket Tracking Forms'}</InputLabel>
          <Select
            value={supplySelections.instantTicketTrackingForms}
            label={'Instant Ticket Tracking Forms'}
            onChange={handleChange}
            name='instantTicketTrackingForms'
          >
            {consumableSupply_unit.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Mega Millions Playslip'}</InputLabel>
          <Select
            value={supplySelections.megaMillions}
            label={'Mega Millions Playslip'}
            onChange={handleChange}
            name='megaMillions'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Millionaire For Life Playslip'}</InputLabel>
          <Select
            value={supplySelections.millionaireForLife}
            label={'Millionaire For Life Playslip'}
            onChange={handleChange}
            name='millionaireForLife'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Powerball Playslip'}</InputLabel>
          <Select
            value={supplySelections.powerball}
            label={'Powerball Playslip'}
            onChange={handleChange}
            name='powerball'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Ticket Stock (Printer Paper)'}</InputLabel>
          <Select
            value={supplySelections.ticketStock}
            label={'Ticket Stock (Printer Paper)'}
            onChange={handleChange}
            name='ticketStock'
          >
            {consumableSupply_rolls.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </>
  );
}
